module.exports = __webpack_public_path__ + "static/media/Ideas.080a2378.jpg";